export default {
    state: {
        user:{},
        accessallowed:[]
    },
    getters: {
        isAdmin:(state)=>{
            return state.user.role && (state.user.role.type==='admin');
        },
        canAccess:(state)=>({configkey=false,tab=false,model=false})=>{
            let response=[];
            if(!state.user || !state.user.id) return response;
            state.accessallowed && state.accessallowed.filter(e=>{
                let allmatched=false;
                if(configkey) allmatched = e.configkey===configkey; 
                if(tab) allmatched = e.tab===tab; 
                if(model) allmatched = e.model===model; 
                return allmatched;
            }).map(e=>{
                let datavalid = e.values && e.values.data;
                switch(configkey){
                    case 'tabs':
                            e.values.data.map(tabs=>{
                                let tab ={
                                    name: tabs.displayName,
                                    icon: 'icon-speedometer',
                                }
                                if(tabs.route) tab.url=tabs.route;
                                tabs.children.map(subtab=>{
                                    if(subtab.default) tab.url=subtab.route;
                                    if(!tab.children) tab.children = [];
                                    tab.children.push({
                                        name: subtab.displayName,
                                        url: subtab.route || '',
                                        icon: 'icon-puzzle'
                                    });
                                });
                                response.push(tab);
                            });
                        break;
                    case 'permissions':
                            e.values.data.map(perm=>{
                                response.push(perm);
                            });
                        break;
                }
                return datavalid ? e : false;
            });

            return response;
        }
    },
    actions:{
        login({state,commit},userwithaccessCred){
            commit('login', userwithaccessCred)
        },
        logout({commit}){
            commit('logout');
        }
    },
    mutations: {
        login(state,{user,accessallowed}){
            state.user=user;
            state.accessallowed= accessallowed;
        },
        logout(state){
            state.user={},
            state.accessallowed=[];
        }
    }
}